import merge from "lodash.merge";
import { setLightness } from "polished";
import { GeneralColorsConfig } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/base/colors.config";
import { FlatColorsConfig } from "@com.mgmtp.a12.widgets/widgets-core/lib/theme/flat/config/base/colors.config";
const ModulFColors = {
    cetaceanBlue: "#000046",
    cetaceanBlueDark: "#000024",
    cetaceanBlueLight: "#091645",
    darkPowderBlue: "#033D99",
    brandeisBlue: "#006FF1",
    brandeisBlueDark: "#1168C0",
    slateBlue: "#715CCF",
    slateBlueDark: "#6653C1",
    azureishWhite: "#DDE9F3",
    azureishWhiteLight: "#EAF5FF",
    azureishWhiteLighter: "#EDF5FC",
    azureishWhiteLightest: "#F7FAFC",
    greenSheen: "#69C1B2",
    greenSheenDark: "#028388",
    blue: "#126ECA",
    green: "#1C7465",
    orange: "#F4CE04",
    red: "#CB104B",
    grey: "#DFE9F3",
    greyDark: "#9E9EBD",
    greyDarkAlternative: "#9393A5",
    greyDarker: "#74748B",
    greyDarkest: "#6B6B80",
    greyLight: "#F0F0F4",
    greyLighter: "#F2F0FA"
};
export const colors = merge({}, FlatColorsConfig, {
    secondaryColor: ModulFColors.azureishWhite,
    text: {
        color: ModulFColors.cetaceanBlueLight,
        secondaryColor: ModulFColors.grey,
        secondaryColorDark: ModulFColors.greyDarker,
        headlineColor: ModulFColors.cetaceanBlueLight,
        titleColor: ModulFColors.cetaceanBlueLight,
        applicationTitle: ModulFColors.brandeisBlueDark,
        applicationTitlePrefix: ModulFColors.slateBlueDark
    },
    background: {
        tertiaryBackground: ModulFColors.grey,
        interactiveBackground: ModulFColors.greyLight,
        groupBackground: ModulFColors.azureishWhiteLight,
        toolbarBackground: ModulFColors.azureishWhite,
        applicationFrameBackground: ModulFColors.azureishWhiteLighter,
        loginLayoutBackground: ModulFColors.azureishWhiteLightest,
        tabPanelBackground: ModulFColors.azureishWhiteLightest
    },
    divider: {
        color: ModulFColors.grey,
        colorDark: ModulFColors.greyDark,
        colorLight: ModulFColors.greyLight
    },
    interaction: {
        color: ModulFColors.brandeisBlueDark,
        colorBG: ModulFColors.azureishWhite,
        primaryInteractionColor: ModulFColors.brandeisBlueDark,
        secondaryInteractionColor: ModulFColors.brandeisBlueDark,
        active: {
            color: ModulFColors.greenSheenDark,
            colorTouch: ModulFColors.brandeisBlueDark
        },
        focus: {
            color: ModulFColors.greenSheenDark
        },
        hover: {
            color: ModulFColors.darkPowderBlue,
            colorInverted: GeneralColorsConfig.white
        },
        selected: {
            color: ModulFColors.slateBlueDark,
            colorLight: ModulFColors.greyLighter,
            colorDark: ModulFColors.brandeisBlueDark
        },
        disabled: {
            color: ModulFColors.greyLight,
            colorLight: ModulFColors.greyLight,
            colorDark: ModulFColors.greyDark
        },
        readonly: {
            color: ModulFColors.greyDark,
            colorDark: ModulFColors.greyDarkest
        },
        draggable: { color: ModulFColors.darkPowderBlue }
    },
    variant: {
        constructiveColor: ModulFColors.green,
        destructiveColor: ModulFColors.red,
        infoColor: ModulFColors.blue,
        infoColorDark: setLightness(0.25, ModulFColors.blue),
        infoColorLight: setLightness(0.95, ModulFColors.blue),
        successColor: ModulFColors.green,
        successColorDark: setLightness(0.25, ModulFColors.green),
        successColorLight: setLightness(0.95, ModulFColors.green),
        warningColor: ModulFColors.orange,
        warningColorDark: setLightness(0.25, ModulFColors.orange),
        warningColorLight: setLightness(0.95, ModulFColors.orange),
        errorColor: ModulFColors.red,
        errorColorDark: setLightness(0.25, ModulFColors.red),
        errorColorLight: setLightness(0.95, ModulFColors.red),
        text: {
            info: ModulFColors.azureishWhiteLightest,
            success: ModulFColors.azureishWhiteLightest,
            warning: ModulFColors.cetaceanBlueLight,
            error: ModulFColors.azureishWhiteLightest
        }
    },
    applicationHeaderHighlight: ModulFColors.slateBlueDark,
    graphicSecondaryColorLight: ModulFColors.greyDarkAlternative,
    graphicSecondaryColorDark: ModulFColors.greyDarker,
    boxShadowBackground: ModulFColors.cetaceanBlueDark,
    highlightColor: ModulFColors.brandeisBlue
});
